import ConnectionErrorAlert from "./components/alert/ConnectionErrorAlert";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import routes from "./routes";
import "bootstrap/dist/css/bootstrap.min.css";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";
import "./assets/loader.css";
import "./assets/global.css";
import "./assets/notification.css";

import Page404 from "./views/page-404/Page404.js";
import WrappedRoute from "./components/wrapped-routes/wrapped-route/WrappedRoute";
import { MountBreadCrubProvider } from "./hooks/useMountBreadCrumb";

const App = () => {
    return (
        <React.Fragment>
            <MountBreadCrubProvider>
                <ConnectionErrorAlert />
                <BrowserRouter basename={process.env.REACT_APP_BASENAME || ""}>
                    <Routes>
                        {routes.map((route, index) => {
                            return (
                                <Route
                                    key={index}
                                    path={route.path}
                                    exact={route.exact}
                                    element={
                                        <WrappedRoute
                                            path={route.path}
                                            isPrivate={route.isPrivate}
                                            route={route}
                                        >
                                            <route.component />
                                        </WrappedRoute>
                                    }
                                />
                            );
                        })}
                        <Route path="*" element={<Page404 />} />
                    </Routes>
                </BrowserRouter>
            </MountBreadCrubProvider>
        </React.Fragment>
    );
};

export default App;
